/* eslint quote-props: 0 */  // --> OFF
/* eslint quotes: 0 */  // --> OFF
import { AppConfig } from '../src/AppConfig';

export const StringTable = [
  {
    "key": "sampleStrKey",
    "en": "Sample"
  },
  {
    "key": "ageLimitSurveyChoiceWarning",
    "en": "For age below " + AppConfig.AGE_UPPER_LIMIT + ", the sections once selected cannot be changed."
  },
  {
    "key": "mandatorySurveyNote",
    "en": "These sections are core to the survey and cannot be unselected."
  },
  {
    "key": "customizeSectionSubtitle",
    "en": "Click on the (i) to learn more about the sections"
  },
  {
    "key": "consentTitleForAgeOverEighteen",
    "en": "Research Subject Information Sheet for Survey"
  },
  {
    "key": "giveConsent",
    "en": "I wish to participate in this study"
  },
  {
    "key": "denyConsent",
    "en": "I do NOT wish to participate in this study"
  },
  {
    "key": "consentSelectError",
    "en": "Please select one option"
  },
  {
    "key": "denyConsentDescr",
    "en": "If you change your mind, you can come back to this consent page with your login information. Hope to see you soon!"
  },
  {
    "key": "infoForAgeUnder18",
    "en": "Thanks for wanting to be a part of this critical effort!\n\n Understanding how teenagers experience menstruation is so important.\n\n Now we need to get the signature of your guardian so you can move forward with the survey!\n\nPlease enter in the email address of a parent or other legal guardian so we can chat with them and see if it's cool with them for you to participate."
  },
  {
    "key": "consentPendingFromParentsStr1",
    "en": "Thanks for wanting to be a part of this critical effort!"
  },
  {
    "key": "consentPendingFromParentsStr2",
    "en": "We are waiting for consent from your parents."
  },
  {
    "key": "giveConsentDescr",
    "en": "Consent document will be downloaded now and survey choices will be saved"
  },
  {
    "key": "reTakeSurvey",
    "en": "You also have the option to retake this section"
  },
  {
    "key": "submitWarning",
    "en": "You will not be able to review or change your answers once you hit submit."
  },
  {
    "key": "consentCompleteMsg1",
    "en": "Consent process is now complete"
  },
  {
    "key": "consentCompleteMsg2",
    "en": "Happy surveying!"
  },
  {
    "key": "successful",
    "en": "Fetch successful"
  },
  {
    "key": "download",
    "en": "Download"
  },
  {
    "key": "imageLoadFail",
    "en": "Image loading failed"
  },
  {
    "key": "unsupportedFunctionality",
    "en": "This functionality is not supported"
  }
]


// WEBPACK FOOTER //
// ./src/StringTable.js